import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../Logo/Logo';
import { SITE_NAME, WHATSAPP_NUMBER, WHATSAPP_DISPLAY, CONTACT_EMAIL, ADDRESS } from '../../data/siteInfo';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          {/* Newsletter Section */}
          <div className="lg:col-span-2">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="mb-4 block"
              aria-label={`${SITE_NAME} home`}
            >
              <Logo variant="light" />
            </button>
            <h3 className="text-white font-bold text-lg sm:text-xl mb-4">
              {SITE_NAME} Insider
            </h3>
            <p className="text-sm mb-4 text-gray-400">
              Your Exclusive Access to Decor Deals & Celebration Trends
            </p>
            <div className="flex flex-col sm:flex-row gap-2">
              <input
                type="email"
                placeholder="E-mail"
                className="flex-1 px-4 py-2 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-400 focus:outline-none focus:border-[#8B1538]"
              />
              <button className="bg-[#8B1538] hover:bg-[#6B0F2A] text-white font-semibold px-6 py-2 rounded-lg transition-colors duration-300">
                Subscribe
              </button>
            </div>
          </div>

          {/* Customer Support */}
          <div>
            <h3 className="text-white font-bold text-lg sm:text-xl mb-4">
              Customer Support
            </h3>
            <div className="space-y-2 text-sm">
              <p>
                WhatsApp:{' '}
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}`}
                  className="hover:text-white transition-colors"
                >
                  {WHATSAPP_DISPLAY}
                </a>
              </p>
              <p>
                Email:{' '}
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="hover:text-white transition-colors"
                >
                  {CONTACT_EMAIL}
                </a>
              </p>
            </div>
          </div>

          {/* Product Categories */}
          <div>
            <h3 className="text-white font-bold text-lg sm:text-xl mb-4">
              Product Categories
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Festivals & Occasion
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Kids Theme
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Adults
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Backdrops
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Paper Hanging
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 sm:mt-12 pt-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 text-sm">
            <div>
              <h4 className="text-white font-semibold mb-3">Company</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    About
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Our Story
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Blog
                  </a>
                </li>
                <li>
                  <a
                    href="/contact"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/contact');
                    }}
                    className="hover:text-white transition-colors"
                  >
                    Contact
                  </a>
                </li>
                <li>
                  <a
                    href="/career"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/career');
                    }}
                    className="hover:text-white transition-colors"
                  >
                    Career
                  </a>
                </li>
                <li>
                  <a
                    href="/faq"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/faq');
                    }}
                    className="hover:text-white transition-colors"
                  >
                    FAQ
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3">Help</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Terms & Condition
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Shipping Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Refund & Service Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3">Our Address</h4>
              <p className="leading-relaxed">{ADDRESS}</p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>© 2026, {SITE_NAME}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

